import '../Global/Style/Calendar.css';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { formatDateToYYYYMMDD } from '../../utils/DateUtils';
import DatePicker from 'react-datepicker';
import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { getContrastTextColor } from '../../utils/ColorUtils';

const Calendar = ({ orders = [], loading = false, onDateChange, filters = {} }) => {
  const navigate = useNavigate();
  const [showDatePicker, setShowDatePicker] = useState(null);

  const groupByDeliveryDate = () => {
    const grouped = {};
    orders.forEach(order => {
      const date = order.deliveryDate?.slice(0, 10);
      if (!date) return;
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(order);
    });
    return grouped;
  };

  const groups = groupByDeliveryDate();
  let orderedDates = Object.keys(groups).sort();
  
  // If no orders, show delivery date range from filters
  if (orders.length === 0 && filters.deliveryDateFrom && filters.deliveryDateTo) {
    orderedDates = [filters.deliveryDateFrom, filters.deliveryDateTo];
  }
  
  const filledDates = fillMissingDates(orderedDates);

  const handleClick = (orderId) => {
    window.open(`/orders/${orderId}`, '_blank');
  };

  const handleDateClick = (currentDate) => {
    setShowDatePicker(currentDate);
  };

  const handleDateSelect = (selectedDate) => {
    const formattedDate = formatDateToYYYYMMDD(selectedDate);
    if (onDateChange) {
      onDateChange(prevFilters => ({
        ...prevFilters,
        deliveryDateFrom: formattedDate,
        deliveryDateTo: formattedDate
      }));
    }
    setShowDatePicker(null);
  };

  return (
    <>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spinner animation="border" />
          <p style={{ marginTop: '10px' }}>Cargando pedidos...</p>
        </div>
      ) : (
        <div className="minimal-order-list-grid no-scroll">
      {filledDates.map(date => {
        const ordersForDate = groups[date] || [];
        const dayLetter = format(new Date(date), 'E', { locale: es }); // Ej: L, M, X...
        const shortDate = format(new Date(date), 'dd/MM');

        return (
          <div className="day-column" key={date}>
            <div className="column-header" onClick={() => handleDateClick(date)} style={{ cursor: 'pointer' }}>
              <div className="order-count">{ordersForDate.length}</div>
              <div>{dayLetter}</div>
              <div>{shortDate}</div>
              {showDatePicker === date && (
                <div style={{ position: 'absolute', zIndex: 1000 }}>
                  <DatePicker
                    selected={new Date(date)}
                    onChange={handleDateSelect}
                    inline
                    onClickOutside={() => setShowDatePicker(null)}
                  />
                </div>
              )}
            </div>
            <div className="order-blocks">
              {ordersForDate.map(order => {
                const name = `${order.client?.name || ''} ${order.client?.lastName1 || ''}`.trim();
                return (
                  <div
                    key={order.id}
                    className="order-block"
                    style={{ 
                      backgroundColor: order.carrier?.colourHex || '#888', 
                      color: getContrastTextColor(order.carrier?.colourHex || '#888'),
                      cursor: 'pointer',
                      border: order.isImportant 
                        ? '2px solid #ff6b35' 
                        : order.hasIncident 
                        ? '2px solid #f44336' 
                        : 'none',
                      boxShadow: order.isImportant 
                        ? '0 0 8px rgba(255, 107, 53, 0.7)' 
                        : order.hasIncident 
                        ? '0 0 4px rgba(244, 67, 54, 0.5)' 
                        : 'none',
                      fontWeight: order.isImportant ? 'bold' : 'normal',
                      margin: order.isImportant ? '2px 0' : '0'
                    }}
                    onClick={() => handleClick(order.id)}
                  >
                    <div className="order-name">
                      {order.isImportant && '⭐ '}
                      {order.hasIncident && '⚠️ '}
                      {name}
                      {order.specialProducts && order.specialProducts.length > 0 && '*'}
                      {order.totalScore > 0 && (
                        <div style={{
                          fontSize: '9px',
                          color: 'rgba(255,255,255,0.7)',
                          marginTop: '1px'
                        }}>
                          {order.totalScore}pts
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
        </div>
      )}
    </>
  );
};

export default Calendar;

const fillMissingDates = (dates) => {
  const sorted = [...dates].sort((a, b) => new Date(a) - new Date(b));
  const filled = [];
  let current = new Date(sorted[0]);
  const end = new Date(sorted[sorted.length - 1]);

  while (current <= end) {
    filled.push(formatDateToYYYYMMDD(current));
    current.setDate(current.getDate() + 1);
  }

  return filled;
};